import api, { apiList } from "../api";
import { integraiton, integraitonTypes } from "../common/types";
import useSWR from "swr";

export function useIntegrations() {
  const { data, error, mutate } = useSWR(
    [apiList.integration.fetchIntegration.url],
    async (url) => {
      const { data } = await api<integraiton[]>(
        apiList.integration.fetchIntegration
      );
      return data;
    },
    {
      revalidateOnFocus: true,
    }
  );

  return {
    integrationList: data || [],
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}

export function useIntegrationTypes() {
  const { data, error, mutate } = useSWR(
    [apiList.integration.fetchIntegrationTypes.url],
    async (url) => {
      const { data } = await api<integraitonTypes[]>(
        apiList.integration.fetchIntegrationTypes
      );
      return data;
    },
    {
      refreshInterval: 0,
      revalidateOnFocus: false,
    }
  );

  return {
    integrationTypes: data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}
